import api from './api'

export const dutyRosterService = {
  options: () => api.get('/api/duty-rosters/options'),
  shifts: (params) => api.get('/api/duty-rosters/shifts', { params }),
  place: (data) => api.post('/api/duty-rosters/shifts', data),
  update: (id, data) => api.patch(`/api/duty-rosters/shifts/${id}`, data),
  remove: (id) => api.delete(`/api/duty-rosters/shifts/${id}`),
  clear: (params) => api.delete('/api/duty-rosters/shifts', { params }),
  generate: (data) => api.post('/api/duty-rosters/generate', data),
  list: () => api.get('/api/duty-rosters'),
  mine: (params) => api.get('/api/duty-rosters/mine', { params }),
  notify: (id) => api.post(`/api/duty-rosters/${id}/notify`),
  save: (data) => api.post('/api/duty-rosters', data),
  removeRoster: (id) => api.delete(`/api/duty-rosters/${id}`),
  load: (id) => api.post(`/api/duty-rosters/${id}/load`)
}
